import moment from "moment"
import React from "react"

const taskTotalHoursConversion = (timeString = "00:00:00") => {
  let finalString = ""
  const tempStringArr = timeString.split(".")
  if (tempStringArr.length > 1) {
    const getHours = tempStringArr[1].split(":")
    const totalHours = parseInt(getHours[0]) + parseInt(tempStringArr[0]) * 24
    finalString = `${totalHours}:${getHours[1]}:${getHours[2]}`
  } else {
    finalString = timeString
  }
  return finalString
}

const groupDataByValue = (data, valueKey) => {
  const groupedData = {}

  data?.forEach(item => {
    const value = item[valueKey]
    if (!groupedData[value]) {
      groupedData[value] = []
    }
    groupedData[value].push(item)
  })

  return groupedData
}

// Function to calculate average time
const calculateAverageTime = times => {
  // Calculate total milliseconds
  const totalMilliseconds = times.reduce(
    (acc, time) => acc + convertTimeToMilliseconds(time),
    0
  )

  // Calculate average milliseconds
  const averageMilliseconds = totalMilliseconds / times.length

  // Convert average milliseconds back to time format (HH:mm:ss)
  const averageTime = convertMillisecondsToTime(averageMilliseconds)

  return averageTime
}

// Function to convert time to milliseconds
const convertTimeToMilliseconds = time => {
  const [hours, minutes, seconds] = time.split(":").map(Number)
  return (hours * 3600 + minutes * 60 + seconds) * 1000
}

// Function to convert milliseconds to time format (HH:mm:ss)
const convertMillisecondsToTime = milliseconds => {
  const date = new Date(milliseconds)
  return date.toISOString().substr(11, 8) // Format as HH:mm:ss
}

// Function to convert duration to formatted time string
// Function to add durations represented as strings and return the result as a formatted time string
const addDurationsAndFormat = times => {
  // Initialize variables to hold total hours, minutes, and seconds
  let totalHours = 0
  let totalMinutes = 0
  let totalSeconds = 0

  // Iterate over each time string in the array
  if (times[0] !== undefined) {
    times?.forEach(timeStr => {
      // Split the time string into hours, minutes, and seconds
      const [hours, minutes, seconds] = timeStr?.split(":")?.map(Number)
      // Add the hours, minutes, and seconds to the totals
      totalHours += hours
      totalMinutes += minutes
      totalSeconds += seconds

      // Adjust the total minutes and seconds if they exceed 60
      if (totalSeconds >= 60) {
        totalMinutes += Math.floor(totalSeconds / 60)
        totalSeconds %= 60
      }
      if (totalMinutes >= 60) {
        totalHours += Math.floor(totalMinutes / 60)
        totalMinutes %= 60
      }
    })

    // Return the formatted total time
    return `${String(totalHours).padStart(2, "0")}:${String(
      totalMinutes
    ).padStart(2, "0")}:${String(totalSeconds).padStart(2, "0")}`
  } else {
    return "00:00:00" // If no times provided, return 0 hours, 0 minutes, 0 seconds
  }
}

const padZero = value => {
  return value > 9 ? value : `0${value}`
}

// Adding private, idle, break hours
const sumofIdleHours = (key, arr, returnValue) => {
  if (arr?.length <= 0) return <></>

  const timesarr = []
  arr?.map((item, index) => {
    timesarr.push(item[key])
  })

  const sum = timesarr?.reduce(
    (acc, time) => acc.add(moment.duration(time)),
    moment.duration()
  )
  if (returnValue)
    return [
      padZero(Math.floor(sum.asHours())),
      padZero(sum.minutes()),
      padZero(sum.seconds()),
    ].join(":")
  return (
    <>
      <strong>
        {[
          padZero(Math.floor(sum.asHours())),
          padZero(sum.minutes()),
          padZero(sum.seconds()),
        ].join(":")}
      </strong>
    </>
  )
}

const formatDate = date => moment(date).format("YYYY-MM-DD")
const formatDateTime = date =>  moment(date).format('YYYY-MM-DDTHH:mm');
const dateStringAt9AM = `${moment().format('YYYY-MM-DD')}T09:00:00`; 

const formatDateString = (date) => {
  const localDate = new Date(date);
  const utcDate = new Date(localDate.getTime() - localDate.getTimezoneOffset() * 60000);
  return utcDate.toISOString();
};

const formateStringofDate = (value) => {
  const datePatterns = [
    { pattern: /\b\d{2}-\d{2}-\d{4}\b/, format: 'DD-MM-YYYY' }, // Matches dd-mm-yyyy format
    { pattern: /\b\d{1,2}\/\d{1,2}\/\d{4}\b/, format: 'MM/DD/YYYY' } // Matches m/d/yyyy or mm/dd/yyyy format
  ];

  let dateMatch;
  let dateStr = '';
  let remainingStr = value;

  // Iterate over the patterns and match the date
  for (const { pattern, format } of datePatterns) {
    dateMatch = value?.match(pattern);
    if (dateMatch) {
      dateStr = dateMatch[0]; // Extract the matched date string
      remainingStr = value?.replace(dateStr, '').trim(); // Remove the date from the string
      dateStr = moment(dateStr, format).format('DD-MM-YYYY'); // Format the date to 'DD-MM-YYYY'
      break;
    }
  }

  return `${remainingStr} ${dateStr}`;
}

const getTimeSplit = (datetime) => {
  return datetime.split('T')[1] || '';
};

const onClosePicker = (newTime, previousDateTime, datetimeInputRef) => {
  const previousTime = getTimeSplit(previousDateTime);
  const newHours = newTime.split(':')[0];
  const newMinutes = newTime.split(':')[1];
  const previousHours = previousTime.split(':')[0];
  const previousMinutes = previousTime.split(':')[1];
  
  if (newMinutes !== previousMinutes || (newHours !== previousHours && newMinutes !== previousMinutes)) {
    if (datetimeInputRef.current) {
      datetimeInputRef.current.blur();
    }
  }
}

export {
  taskTotalHoursConversion,
  groupDataByValue,
  calculateAverageTime,
  addDurationsAndFormat,
  sumofIdleHours,
  formatDate,
  formateStringofDate,
  getTimeSplit,
  onClosePicker,
  formatDateTime,
  formatDateString,
  dateStringAt9AM
}
